// Ide kerülnek a service saját type, interface, tömb, constans, stb. definíciói.

import type { IConfigAuth, IConfigStructure } from '@common/backend/definitions'

export enum EUsersRoute {
  GetUserNamesByIds = '/us/api/users/get-user-names-by-ids',
  GetAllWithRoles   = '/us/api/users/get-all-with-roles',
  GetAll            = '/us/api/users/get-all',
  Insert            = '/us/api/users/insert',
  Update            = '/us/api/users/update',
  Get               = '/us/api/users/get'
}

export enum ERolesRoute {
  GetAll = '/us/api/roles/get-all',
  Get    = '/us/api/roles/get',
  Insert = '/us/api/roles/insert',
  Update = '/us/api/roles/update'
}

export enum EUserRolesRoute {
  GetByUser          = '/us/api/user-roles/get-by-user',
  GetUsers           = '/us/api/user-roles/get-users',
  Copy               = '/us/api/user-roles/copy',
  DeleteRoleFromUser = '/us/api/user-roles/delete-from-user',
  AddRoleToUser      = '/us/api/user-roles/add-to-user'
}

export enum EAuthRoute {
  Validate  = '/us/api/auth/validate',
  Login     = '/us/api/auth/login',
  Logout    = '/us/api/auth/logout',
  HasRole   = '/us/api/auth/has-role'
}

export interface ILogin {
  readonly username: string
  readonly password: string
}

export interface ILoginResponse {
  readonly loginHash: string
}

/** Egyetlen jogosultság adatbázisreprezentációja. */
export interface IRole {
  readonly id: number
  readonly key: string
  readonly description: string
}

/** Jogosultságok listája. */
export type TRoles = readonly IRole[]

export interface IConfig extends IConfigStructure, IConfigAuth {}

export type TRole = (
  /** Dolgókra vonatkozó szabályzatok. */
  'regulations' |

  'storage' |
  /** Delegálhat feladatot? */
  'storage.tasks.delegate' |
  /** Tud törölni feladatot? */
  'storage.tasks.delete' |
  /** Adhat hozzá feladatot? */
  'storage.tasks.insert' |
  /** Exprtálhatja a feladatokat? */
  'storage.tasks.export' |
  /** Állíthat befejezettre feladatot? */
  'storage.tasks.finish' |
  /** Alaphelyzetbe állítja a feladatot. */
  'storage.tasks.reset' |
  /** Láthatja a gyártási feladatok menüpontot? */
  'storage.tasks.manufacture' |
  /** Láthatja a szállítási feladatok menüpontot? */
  'storage.tasks.delivery' |
  /** Láthatja és állíthatja a tartozókat. */
  'storage.tasks.obligation' |
  /** Láthatja az analitikát a feladatokhoz. */
  'storage.tasks.analytics' |
  /** Engedély, hogy láthassa a raktárfeladatos modult. */
  'storage.tasks' |
  /** Engedély, hogy megváltoztassa a munkavégzőt. */
  'storage.tasks.changeWorker' |
  /** Engedély, hogy láthassa az adott cég munkáit. */
  `storage.tasks.company.${ number }` |

  /** Engedély, hogy a webscrapert láthassa. */
  'scrapers' |

  /** Engedély, hogy beléphet a nyelvesítőrendszerünkbe. */
  'langedit' |
  'langedit.apps' |
  'langedit.stats' |
  'langedit.apps.insert' |
  'langedit.apps.update' |
  'langedit.apps.delete' |
  'langedit.translations' |
  'langedit.translations.insert' |
  'langedit.translations.update' |
  'langedit.translations.delete' |
  'langedit.translations.deleteAll' |
  'langedit.translations.import' |
  'langedit.translations.export' |

  /** Konkurencia. */
  'competition' |
  'competition.products' |
  'competition.products.insert' |
  'competition.products.update' |
  'competition.products.import' |
  'competition.products.export' |
  'competition.products.delete' |

  'shoprenter' |
  'shoprenter.pendingProducts' |
  'shoprenter.pendingProducts.insert' |
  'shoprenter.pendingProducts.delete' |
  'shoprenter.pendingProducts.import' |
  'shoprenter.pendingProducts.export' |
  'shoprenter.pendingProducts.update' |
  'shoprenter.pendingProducts.upload' |
  'shoprenter.pendingProducts.updateDescription' |
  'shoprenter.pendingProducts.reason.update' |

  'shoprenter.bdidactPendingProducts' |
  'shoprenter.bdidactPendingProducts.insert' |
  'shoprenter.bdidactPendingProducts.delete' |
  'shoprenter.bdidactPendingProducts.import' |
  'shoprenter.bdidactPendingProducts.export' |
  'shoprenter.bdidactPendingProducts.update' |
  'shoprenter.bdidactPendingProducts.upload' |
  'shoprenter.bdidactPendingProducts.setWrong' |
  'shoprenter.bdidactPendingProducts.repair' |
  'shoprenter.bdidactWebshopProducts' |

  'shoprenter.processedProducts' |
  'shoprenter.uploadedProducts' |
  'shoprenter.missingProducts' |
  'shoprenter.webshop' |
  'shoprenter.analytics' |

  'shoprenter.webshop.massEnable' |
  'shoprenter.webshop.massDisable' |
  'shoprenter.webshop.massRunOut' |
  'shoprenter.webshop.modify' |
  'shoprenter.webshop.pending' |
  'shoprenter.webshop.delete' |
  'shoprenter.webshop.images' |
  'shoprenter.webshop.images.edit' |

  'shoprenter.webshop.export.products' |

  'shoprenter.webshop.modify.name' |
  'shoprenter.webshop.modify.description' |
  'shoprenter.webshop.modify.category' |
  'shoprenter.webshop.modify.status' |
  'shoprenter.webshop.modify.orderable' |
  'shoprenter.webshop.modify.seo' |

  'shoprenter.webshop.categories' |
  'shoprenter.webshop.manufacturers' |
  'shoprenter.webshop.waitingListRequests' |

  'shoprenter.problematicProducts' |
  'shoprenter.problematicProducts.insert' |
  'shoprenter.problematicProducts.delete' |
  'shoprenter.problematicProducts.update' |
  'shoprenter.problematicProducts.modify' |
  'shoprenter.problematicProducts.stateChange' |

  'shoprenter.development.domains'  |
  'shoprenter.development.scripts'  |
  'shoprenter.development.settings' |
  'shoprenter.development.hooks' |

  'shoprenter.webshop.onlyBdidactActivate' |

  'shoprenter.vectoryProducts' |
  'shoprenter.vectoryProducts.manualStockUpdate' |

  'productsharing' |
  'productsharing.enable' |

  'powerhouse' |
  'powerhouse.roles' |
  'powerhouse.users' |
  'powerhouse.users.insert' |
  'powerhouse.users.update' |
  'powerhouse.users.copy' |

  'productreceiving' |

  /** A termékek listában csak a feltöltésre vár állapotú termékeket látja. */
  'productreceiving.products.filter.waitForUpload' |

  /** Van hozzáférése a hibás termékek felülethez. */
  'defectiveproduct' |

  /** Árajánlatok, számlák. */
  'offerAndInvoicing' |
  'offerAndInvoicing.canEdit' |

  /** Fejlesztői csapat monitorozó rendszere. */
  'monitor' |

  /** Megrendelések kezelése. */
  'orders' |

  /** Bejövő árajánlatok. */
  'incomingOffers' |
  'incomingOffers.source.taneszkoz' |
  'incomingOffers.source.bdovi' |
  'incomingOffers.source.bdro' |

  /** Activator. */
  'activator' |

  /** Raktár költést kezelés. */
  'warehouse' |

  'warehouse.card' |
  'warehouse.client.massInsert' |
  'warehouse.client.sync' |
  'warehouse.debt' |
  'warehouse.debt.massInsert' |
  'warehouse.invoice.massInsert' |
  'warehouse.invoice.superDelete' |
  'warehouse.invoicesA' |
  'warehouse.invoicesB' |
  'warehouse.invoicesC' |
  'warehouse.parcelService.update' |
  'warehouse.parcelService.delete' |
  'warehouse.invoice.onBank.edit' |
  'warehouse.invoicesA.update' |
  'warehouse.invoicesB.update' |
  'warehouse.invoicesC.update' |
  'warehouse.invoicesA.delete' |
  'warehouse.invoicesB.delete' |
  'warehouse.invoicesC.delete' |

  /** Tud fordítani AI segítségével? */
  'ai.translate' |

  /** Ügyesedni admin hozzáférés. */
  'ugyesedni.admin' |

  /** Blog; itt egyelőre csak és kizárólag egy jogosultságként kezelünk mindent. */
  'blog'
)

export interface IUserRole {
  readonly userId: number
  readonly key: TRole
  readonly value: number
  readonly roleId: number
}

export type TUserRoles = readonly IUserRole[]

export type TDbRoles = readonly [
  roleId: number,
  value: number
][]

/** Egy felhasználót reprezentáló objektum. */
export interface IUser {
  /** A felhasználó azonosítója. */
  readonly id: number

  /** A felhasználó teljes neve. */
  readonly fullname: string

  /** Beosztás, leírás, bármi. */
  readonly description: string

  /** A felhasználó neve. */
  readonly username: string

  /** A felhasználó e-mail címe. */
  readonly email: string | null

  /** Ha belépett már egyszer, akkor az első belépés dátuma. */
  readonly firstLoginAt: string | null

  /** A legutóbbi belépés dátuma. */
  readonly lastLoginAt: string | null

  /** Soft delete törölve lett a felhasználó? */
  readonly isDeleted?: boolean
}

/** A felhasználó a jogosultságaival. */
export interface IUserWithRoles extends IUser {
  readonly roles: TUserRoles
}

/** Felhasználók listája, jogosultságokkal. */
export type TUsersWithRoles = readonly IUserWithRoles[]

/** Felhasználók listája. */
export type TUsers = readonly IUser[]

/** Minimális felhasználónézet, amelyet más szolgáltatások használnak megjelenítésre. */
export interface IMinimalUser {
  /** A felhasználó azonosítója. */
  readonly id: number
  /** A felhasznál neve. */
  readonly username: string
}

export type TMinimalUsers = readonly IMinimalUser[]

/** Felhasználók lekérdezése azonosítók szerint. */
export interface IGetUserNamesByIdsRequest {
  readonly ids: readonly number[]
}

export interface IGetUserNamesByIdsResponse {
  readonly minimalUsers: TMinimalUsers
}

export interface IRoleValue {
  readonly id: number
  readonly value: number
}

export type TRoleValues = readonly IRoleValue[]

export interface IBaseUser {
  readonly description: string
  readonly fullname: string
  readonly username: string
  readonly email: string
  readonly password: string

}

/** Új felhasználó beszúrásakor küldendő request. */
export interface IUserInsertRequest extends IBaseUser {
  readonly roles: TRoleValues
}

/** Jogosultságok másolásakor küldendő request. */
export interface IUserCopyRequest {
  readonly sourceUserId: number
  readonly targetUserId: number
}

/** Ez csak alias, ugyanazt tudja, mint a beszúrás. */
export interface IUserUpdateRequest extends IUserInsertRequest {
  readonly userId: number
}

/** Egy user lekérdezésekor küldendő válasz. */
export interface IUserGetResponse {
  readonly user: IUser
  readonly roles: TUserRoles
}

export interface IRoleGetRequest {
  readonly roleId: number
}

export interface IUsersByRoleRequest {
  readonly roleId: number
}

export interface IRoleByUserRequest {
  readonly roleId: number
  readonly userId: number
}

/** Egy jogosultság elkérésekor a szerver válasza. */
export interface IRoleGetReponse {
  readonly role: IRole
}

/** Új jogosultság beszúrásakor ezt a requestet küldi a kliens. */
export interface IRoleInsertRequest {
  readonly key: string
  readonly description: string
}

/** Egy jogosultság módosításakor küldött request. */
export interface IRoleUpdateRequest extends IRoleInsertRequest {
  readonly id: number
}

export enum EUserState {
  Active      = 0,
  Deactivated = 1
}

export interface IWithStocRequest {
  readonly stoc: string
}
